import type { ReactElement, ReactNode } from 'react';
import * as st from './styles.module.scss';

interface Props {
  title: string;
  value?: ReactNode;
  suffix?: string;
  suffixClass?: string;
  className?: string;
  action?: () => ReactElement;
}

export const ItemWithAction: React.FC<Props> = ({
  title,
  value = null,
  suffix = '',
  suffixClass,
  className,
  action,
}) => (
  <li className={st.item}>
    <span className={st.item__title}>{title}</span>
    <div className={`${value ? st.item__value : st.item__empty} ${className || ''}`}>
      {value}
      <span className={suffixClass}>{suffix}</span>
    </div>
    {action && action()}
  </li>
);
